import { Box, Button, FormLabel, IconButton, Modal } from '@mui/material';
import React from 'react';
import { CSVLink } from 'react-csv';
import Iconify from '../../iconify/Iconify';
import '../../../css/style.css';

function Employer(props) {
  const { uploadopen, handelok, typeError, handleFile, handleuploadClose, excelFile, Filename } = props;

  const header = [
    {
      EmployerName: 'TCS',
      // EmployerId: 'TCS-1',
      OwnerShip: 'fgvhfghf',
      Industry: 'IT Services',
      Address: 'Gandhinagar',
      PinCode: '395845',
      LowestSalary: '25000',
      HighestSalary: '125000',
      TotalSalaryOutflow: '2500000',
      Website: 'https://www.tcs.com/',
      SocialMedia: 'https://www.tcs.com/',
      Email: 'contact@tcs.com',
      Phone: '9999999999',
      SPOCName: 'TCS',
      SPOCContactInfo: 'info@tcs.com',
      SOPCDesign: 'tcsdesign',
      TransactionFee: '2.3',
    },
  ];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 10,
    p: 2,
  };

  const labels = {};

  return (
    <>
      {/* New Users */}

      <Modal
        open={uploadopen}
        onClose={handleuploadClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ fontSize: '18px', fontWeight: '700' }}>Upload employer file</div>
          <Button style={{ margin: 'auto', marginTop: '10px' }} variant="contained">
            <CSVLink
              style={{ color: 'white', textDecoration: 'none' }}
              data={header}
              filename="Employer
            .csv"
              target=""
            >
              Download Sample
            </CSVLink>
          </Button>

          <div style={{ marginTop: '10px' }}>
            <form>
              <FormLabel className="file-input__label" htmlFor="file-input">
                <Iconify icon={'material-symbols:upload-sharp'} />
                <Box>Upload File</Box>
                <Box sx={{ fontSize: '14px' }}>{Filename}</Box>
              </FormLabel>
              <input type="file" id="file-input" className="file-input__input" required onChange={handleFile} />
            </form>
            {typeError && (
              <div style={{ color: 'red' }} className="alert alert-danger" role="alert">
                {typeError}
              </div>
            )}
          </div>

          {/* <div style={{ marginTop: '20px' }}>
            <form>
              <FormLabel className="file-input__label" htmlFor="file-input">
                {excelFile ? 'Upload File' : 'Upload File'}
              </FormLabel>
              <input type="file" id="file-input" className="file-input__input" required onChange={handleFile} />
            </form>
            {typeError && (
              <div className="alert alert-danger" style={{ color: 'red' }} role="alert">
                {typeError}
              </div>
            )}
          </div> */}
          <Button style={{ width: '100%', margin: 'auto', marginTop: '10px' }} onClick={handelok} variant="contained">
            UPLOAD
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default Employer;
